import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { API_ENDPOINT } from 'api/constants';
import { SSEEventType } from 'constants/sse';
import { RootState } from 'store';
import { setConnectionStatus, setData } from 'store/slices/sseSlice';


let eventSourceInstance: EventSource | null = null;

const getEventSource = () => {
  if (!eventSourceInstance) {
    const token = localStorage.getItem('token');
    const eroGuestId = localStorage.getItem('ero_guest_id');

    const urlObj = new URL(`${API_ENDPOINT}/sse/init`);
    if (token) urlObj.searchParams.append('token', token);
    if (eroGuestId) urlObj.searchParams.append('ero_guest_id', eroGuestId);

    eventSourceInstance = new EventSource(urlObj.toString());
  }
  return eventSourceInstance;
};

const useSSEConnection = (currentUser?: unknown) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!currentUser) {
      return;
    }

    const eventSource = getEventSource();

    const handleConnectionEstablished = (event: MessageEvent) => {
      const data = JSON.parse(event.data);
      dispatch(setConnectionStatus(true));
      dispatch(setData({ ...data, eventType: SSEEventType.CONNECTION_ESTABLISHED }));
    };



    const handleHeartbeat = (event: MessageEvent) => {
      const data = JSON.parse(event.data);
      dispatch(setData({ ...data, eventType: SSEEventType.HEARTBEAT }));
    };

    const handleError = () => {
      dispatch(setConnectionStatus(false));

      setTimeout(() => {
        eventSourceInstance?.close();
        eventSourceInstance = null;
        getEventSource();
      }, 5000);
    };

    const handleCustomDialogPhotoGen = (event: MessageEvent) => {
      const data = JSON.parse(event.data);
      dispatch(setData({ ...data, eventType: SSEEventType.CUSTOM_DIALOG_PHOTO_GEN, taskId: data.taskId }));
    };

    const handleAvatarGenerated = (event: MessageEvent) => {
      const data = JSON.parse(event.data);
      dispatch(setData({ ...data, eventType: SSEEventType.AVATAR_GENERATED }));
    };

    const handlePermanentClose = () => {
      eventSourceInstance?.close();
      eventSourceInstance = null;
      dispatch(setConnectionStatus(false));
    };

    // Очистка перед добавлением новых слушателей (защита от дублирования)
    eventSource.removeEventListener(SSEEventType.CONNECTION_ESTABLISHED, handleConnectionEstablished);
    eventSource.removeEventListener(SSEEventType.HEARTBEAT, handleHeartbeat);
    eventSource.removeEventListener(SSEEventType.ERROR, handleError);
    eventSource.removeEventListener(SSEEventType.CUSTOM_DIALOG_PHOTO_GEN, handleCustomDialogPhotoGen);
    eventSource.removeEventListener(SSEEventType.AVATAR_GENERATED, handleAvatarGenerated);

    eventSource.addEventListener(SSEEventType.CONNECTION_ESTABLISHED, handleConnectionEstablished);
    eventSource.addEventListener(SSEEventType.HEARTBEAT, handleHeartbeat);
    eventSource.addEventListener(SSEEventType.ERROR, handleError);
    eventSource.addEventListener(SSEEventType.CUSTOM_DIALOG_PHOTO_GEN, handleCustomDialogPhotoGen);
    eventSource.addEventListener(SSEEventType.AVATAR_GENERATED, handleAvatarGenerated);
    eventSource.addEventListener(SSEEventType.PERMANENT_CLOSE, handlePermanentClose);

    return () => {
      eventSource.removeEventListener(SSEEventType.CONNECTION_ESTABLISHED, handleConnectionEstablished);
      eventSource.removeEventListener(SSEEventType.HEARTBEAT, handleHeartbeat);
      eventSource.removeEventListener(SSEEventType.ERROR, handleError);
      eventSource.removeEventListener(SSEEventType.CUSTOM_DIALOG_PHOTO_GEN, handleCustomDialogPhotoGen);
      eventSource.removeEventListener(SSEEventType.AVATAR_GENERATED, handleAvatarGenerated);
      eventSource.removeEventListener(SSEEventType.PERMANENT_CLOSE, handlePermanentClose);
    };
  }, [dispatch, currentUser]);

  return {
    isConnected: useSelector((state: RootState) => state.sse.isConnected),
    error: useSelector((state: RootState) => state.sse.error)
  };
};

export default useSSEConnection;
